import { motion, HTMLMotionProps, Variants } from 'framer-motion';
import { ReactNode } from 'react';
import { staggerItem, staggerItemScale } from '@/lib/motion/variants';
import { useReducedMotion } from '@/lib/motion/hooks/use-reduced-motion';

interface StaggerItemProps extends Omit<HTMLMotionProps<'div'>, 'children'> {
  children: ReactNode;
  className?: string;
  /** Include subtle scale effect */
  withScale?: boolean;
  /** Custom variants */
  variants?: Variants;
}

export function StaggerItem({
  children,
  className,
  withScale = false,
  variants,
  ...props
}: StaggerItemProps) {
  const reducedMotion = useReducedMotion();

  if (reducedMotion) {
    return <div className={className}>{children}</div>;
  }

  const itemVariants = variants || (withScale ? staggerItemScale : staggerItem);

  return (
    <motion.div
      variants={itemVariants}
      className={className}
      {...props}
    >
      {children}
    </motion.div>
  );
}
